import React from 'react';
import { useTranslation } from 'react-i18next';
import './SetupWizardSteps.css';

const Step13Completion = ({ onFinish }) => {
  const { t } = useTranslation('setup');

  return (
    <div className="step-content">
      <div className="step-section" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>🎉</div>
        <h2 style={{ marginBottom: '16px' }}>{t('step13.title')}</h2>
        <h3 style={{ marginBottom: '24px', color: '#666', fontWeight: 'normal' }}>
          {t('step13.subtitle')}
        </h3>
        <p style={{ fontSize: '16px', color: '#666', maxWidth: '600px', margin: '0 auto 32px' }}>
          {t('step13.description')}
        </p>
      </div>

      <div className="completion-summary" style={{ marginTop: '32px', padding: '24px', backgroundColor: '#f5f5f5', borderRadius: '8px', maxWidth: '600px', margin: '0 auto' }}>
        <h4 style={{ marginBottom: '16px' }}>{t('step13.whatsNextTitle')}</h4>
        <ul style={{ textAlign: 'left', lineHeight: '1.8' }}>
          <li>{t('step13.whatsNext.ready')}</li>
          <li>{t('step13.whatsNext.protocols')}</li>
          <li>{t('step13.whatsNext.risks')}</li>
          <li>{t('step13.whatsNext.compliance')}</li>
          <li>{t('step13.whatsNext.workflows')}</li>
        </ul>
      </div>

      <div className="completion-actions" style={{ marginTop: '32px', textAlign: 'center' }}>
        <button
          type="button"
          className="btn btn-primary btn-large"
          onClick={onFinish}
        >
          {t('step13.startButton')}
        </button>
      </div>
    </div>
  );
};

export default Step13Completion;
